import {
  GET_ACCESORIES,
  ACCESORIES_ERROR,
  LOADING_ACCESSORIES,
} from '../actions/types';

const initialState = {
  accessories: [],
  loading: true,
  error: {},
};

export default (state = initialState, action) => {
  const {type, payload} = action;
  switch (type) {
    case LOADING_ACCESSORIES:
      return {
        ...state,
        loading: true,
      };
    case GET_ACCESORIES:
      return {
        ...state,
        accessories: payload,
        loading: false,
      };
    case ACCESORIES_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
};
